import { SignDirectionRemoveIcon } from './SignDirectionRemoveIcon';

/**
 * author: Michael Richins
 * id 93DA424E-0D38-4DD4-B06A-2E3D0754EEC0
 * name sign-direction-remove
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sign-direction-remove.svg
 * tags
 */
export const MilestoneRemoveIcon = SignDirectionRemoveIcon;
export default MilestoneRemoveIcon